import React, { useEffect, useState } from 'react';
import '../assets/css/custom.css';
import '../assets/css/client.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faPenToSquare, faPhone } from '@fortawesome/free-solid-svg-icons';
import NoBuilding from "../assets/img/no-category-icon.png";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import TowerIcon from "../assets/img/ss-tile.png";
import { commonAPI } from "../services/CommonAPIService";
import { ErrorSource } from '../common/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

function PriorityContacts() {
    const [ContactsList, setContactsList] = useState([]);
    const [ContactTypes, setContactTypes] = useState([]);
    const [ContactId, setContactId] = useState("");
    const [ContactName, setContactName] = useState("");
    const [ContactTypeId, setContactTypeId] = useState("");
    const [ContactNumber, setContactNumber] = useState("");
    const [AccessDays, setAccessDays] = useState("");
    const [AccessTime, setAccessTime] = useState("");
    const [IsWhatsAppEnabled, setIsWhatsAppEnabled] = useState(false);
    const [EmailAddress, setEmailAddress] = useState("");
    const [DisplaySeq, setDisplaySeq] = useState("");
    const [Loading, setLoading] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddContactBtn, setAddContactBtn] = useState(false);
    const [UpdateContactBtn, setUpdateContactBtn] = useState(false);
    const [DeleteShow, setDeleteShow] = useState(false);
    const [SelectedContactId, setSelectedContactId] = useState("");
    const [show, setShow] = useState(false);

    const setInputValue = (item) => {
        setShow(true);
        setAddContactBtn(false);
        setUpdateContactBtn(true);
        setContactName(item?.contactName);
        setContactId(item?.contactId);
        setContactTypeId(item?.contactTypeId);
        setContactNumber(item?.contactNumber);
        setAccessDays(item?.accessDays);
        setAccessTime(item?.accessTimeRange)
        setIsWhatsAppEnabled(item?.isWhatsAppEnabled);
        setEmailAddress(item?.emailAddress);
        setDisplaySeq(item?.displaySeq);
    };

    const openCreateModal = () => {
        setShow(true);
        setAddContactBtn(true);
        setUpdateContactBtn(false);
        setContactName("");
        setContactTypeId("");
        setContactNumber("");
        setAccessDays("");
        setIsWhatsAppEnabled(false);
        setEmailAddress("");
        setDisplaySeq("");
    };

    const GetContactTypes = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        setLoading(true);
        try {
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            setLoading(true);
            let response = await commonAPI("PriorityContactType", undefined, endPointVariableKey);
            if (response?.success === true) {
                setContactTypes(response?.data);
                setLoading(false);
            } else {
                toast.error("Failed to fetch contact types");
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            toast.error("Something went wrong");
        }
    };

    const GetContactsList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        setLoading(true);
        try {
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            let response = await commonAPI("PriorityContacts", undefined, endPointVariableKey);
            console.log("PriorityContacts", response)
            if (response?.success === true) {
                setContactsList(response?.data);
                setLoading(false);
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/PriorityContacts",
                "errorNumber": "PC01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "PriorityContacts.js",
                "functionName": "GetContactsList",
            };
            await commonAPI("ErrorLogMaster", bodyError);
            toast.error("Something went wrong");
        }
    };

    useEffect(() => {
        GetContactsList();
        GetContactTypes();
    }, []);

    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setSelectedContactId(item);
    };

    const DeleteContact = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        try {
            const endPointVariableKey = {
                urlVariable: SelectedContactId?.contactId,
                buildingId: myUserData?.buildingId

            }
            setLoading(true);
            let response = await commonAPI(`PriorityContactsDelete`, undefined, endPointVariableKey);
            if (response?.success === true && response?.message?.length === 0) {
                toast.success("Contact Deleted");
                GetContactsList();
                setDeleteShow(false);
            } else {
                toast.error(response.message[0]);
            }
        } catch (error) {
            console.log(error);
            const bodyError = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": `/api/Master/PriorityContacts/${SelectedContactId?.contactId}`,
                "errorNumber": "PD01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "PriorityContacts.js",
                "functionName": "DeleteContact",
            };
            await commonAPI("ErrorLogMaster", bodyError);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const addNewContact = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodydata = {
            createdUserId: JSON.stringify(myUserData?.userId),
            contactName: ContactName,
            contactTypeId: parseInt(ContactTypeId),
            contactNumber: ContactNumber,
            accessDays: AccessDays,
            accessTimeRange: AccessTime,
            isWhatsAppEnabled: IsWhatsAppEnabled,
            emailAddress: EmailAddress,
            displaySeq: parseInt(DisplaySeq) || 0,
        };
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            if (!ContactName) {
                toast.warning("Please enter Contact Name");
                return;
            }
            if (!ContactTypeId){
                toast.warning("Please select Contact Type")
                return
            }
            if (!ContactNumber) {
                toast.warning("Please enter Contact Number");
                return;
            }
            if (ContactNumber.length !== 10) {
                toast.warning("Contact Number must be 10 digits");
                return;
            }
            let response = await commonAPI("PriorityContactsAdd", bodydata, endPointVariableKey);
            if (response?.success === true && response?.message?.length === 0) {
                toast.success("Contact Added");
                GetContactsList();
                setShow(false);
            } else {
                toast.error(response?.message[0]);
            }
        } catch (error) {
            console.log(error);
            const bodyError = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/Master/PriorityContacts",
                "errorNumber": "PA01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "PriorityContacts.js",
                "functionName": "addNewContact",
            };
            await commonAPI("ErrorLogMaster", bodyError);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const UpdateContact = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const bodyData = {
            modifiedUserId: JSON.stringify(myUserData?.userId),
            contactName: ContactName,
            contactId: ContactId,
            contactTypeId: parseInt(ContactTypeId),
            contactNumber: ContactNumber,
            accessDays: AccessDays,
            accessTimeRange: AccessTime,
            isWhatsAppEnabled: IsWhatsAppEnabled,
            emailAddress: EmailAddress,
            displaySeq: parseInt(DisplaySeq) || 0,
        };
        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            if (!ContactName) {
                toast.warning("Please enter Contact Name");
                return;
            }
            if (!ContactTypeId){
                toast.warning("Please select Contact Type")
                return
            }
            if (!ContactNumber) {
                toast.warning("Please enter Contact Number");
                return;
            }
            if (ContactNumber.length !== 10) {
                toast.warning("Contact Number must be 10 digits");
                return;
            }
            let response = await commonAPI("PriorityContactsUpdate", bodyData, endPointVariableKey);
            if (response?.success === true && response?.message?.length === 0) {
                toast.success("Contact Updated");
                GetContactsList();
                setShow(false);
            } else {
                toast.error(response?.message[0]);
            }
        } catch (error) {
            console.log(error);
            const bodyError = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Master/PriorityContacts",
                "errorNumber": "PU01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "PriorityContacts.js",
                "functionName": "UpdateContact",
            };
            await commonAPI("ErrorLogMaster", bodyError);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {Loading ?
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div>
                : null}
            <ToastContainer />
            <style>
                {`
                [type="checkbox"]{
                        opacity: 0 !important;
                }
                `
            }
            </style>
            <div className="row mb-3 mt-5 pt-5" style={{ alignItem: 'center' }}>
                <div className="col-lg-6 col-md-6">
                    <div className="HeadingTop">
                        <h3>Priority Contacts</h3>
                        <span>Manage important contact information for quick access.</span>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 mb-3 mb-md-0 text-right" style={{ alignContent: 'center' }}>
                    <Button variant="btn btn-info" onClick={() => openCreateModal()}>+ Create New</Button>{' '}
                </div>
            </div>

            <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton className='headerMDL'>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {UpdateContactBtn ? <>Update Contact</> : <>Add Contact</>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="helpingElelemnt_uuy002">
                    <div className="row" id="validation">
                        <div className="col-12">
                            <div className="card-body p-0">
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    <div className="content clearfix">
                                        <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                            <div className="row text-left">
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-group">
                                                        <label htmlFor="contactName">Contact Name <span className="danger">*</span></label>
                                                        <input type="text" value={ContactName} onChange={(e) => setContactName(e.target.value)} className="form-control required" id="contactName" name="contactName" aria-required="true" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-group">
                                                        <label htmlFor="contactTypeId">Contact Type <span className="danger">*</span></label>
                                                        <select value={ContactTypeId} onChange={(e) => setContactTypeId(e.target.value)} style={{height: 35}} className="form-control required" id="contactTypeId" name="contactTypeId">
                                                            <option value="">Select Type</option>
                                                            {ContactTypes?.map((type, index) => (
                                                                <option key={index} value={type.contactTypeId}>{type.contactType}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2 d-flex">
                                                    <div className="form-group">
                                                        <label htmlFor="contactNumber">Contact Number <span className="danger">*</span></label>
                                                        <input type="text" value={ContactNumber} onChange={(e) => setContactNumber(e.target.value)} className="form-control" id="contactNumber" name="contactNumber" />
                                                    </div>
                                                    <div className="form-group" style={{display: "grid", alignItems: "center", marginLeft: 40}}>
                                                        <input type="checkbox" style={{marginRight: -10}} checked={IsWhatsAppEnabled} onChange={(e) => setIsWhatsAppEnabled(e.target.checked)} id="isWhatsAppEnabled" name="isWhatsAppEnabled" />
                                                        <label htmlFor="isWhatsAppEnabled">WhatsApp Enabled
                                                            <span title="WhatsApp Enabled" style={{ color: IsWhatsAppEnabled ? "#25D366" : "#5F6368", marginLeft: 8, fontSize: 22 }}>
                                                                <FontAwesomeIcon icon={faWhatsapp} />
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                                 <div className="col-md-12 mb-2">
                                                    <div className="form-group">
                                                        <label htmlFor="emailAddress">Email Address</label>
                                                        <input type="email" value={EmailAddress} onChange={(e) => setEmailAddress(e.target.value)} className="form-control" id="emailAddress" name="emailAddress" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-group">
                                                        <label htmlFor="accessDays">Access Days</label>
                                                        <textarea value={AccessDays} onChange={(e) => setAccessDays(e.target.value)} className="form-control" id="accessDays" name="accessDays" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-group">
                                                        <label htmlFor="accessDays">Access Time</label>
                                                        <textarea value={AccessTime} onChange={(e) => setAccessTime(e.target.value)} className="form-control" id="accessTime" name="accessTime" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-2">
                                                    
                                                </div>
                                               
                                                <div className="col-md-12 mb-2">
                                                    <div className="form-group">
                                                        <label htmlFor="displaySeq">Display Sequence</label>
                                                        <input type="number" value={DisplaySeq} onChange={(e) => setDisplaySeq(e.target.value)} className="form-control" id="displaySeq" name="displaySeq" />
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <div className="fixed_allbtn">
                    <div className="upload_btn">
                        <ul role="menu" aria-label="Pagination" className='mb-0'>
                            {AddContactBtn ?
                                <div className="align-self-start">
                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}>Cancel</button>
                                    <button type="button" className="btn btn-info" onClick={() => addNewContact()}>Submit</button>
                                </div>
                                : null}
                            {UpdateContactBtn ?
                                <div className="align-self-start">
                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}>Cancel</button>
                                    <button type="button" className="btn btn-info" onClick={() => UpdateContact()}>Update</button>
                                </div>
                                : null}
                        </ul>
                    </div>
                </div>
            </Modal>

            <div className="row">
                <div className="col-12">
                    <div id="example23_wrapper" className="dataTables_wrapper pt-0">
                        <div className="row">
                            {!ContactsList?.length && ContactsList?.length != null ?
                                <div className='bg-white' style={{ paddingBottom: "50px", borderRadius: "10px" }}>
                                    <div className='col-12 text-center'>
                                        <img src={NoBuilding} alt="user" className="mx-auto mt-5" style={{ height: "100px" }} />
                                    </div>
                                    <br />
                                    <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}>No Contacts found</h3>
                                    <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}>Click on Create New button to add a Contact</h5>
                                </div> : null}
                            {ContactsList?.map((item, index) => (
                                <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                                    <div className="clientTiles" style={{ height: 170 }}>
                                        <div className="ClientImg">
                                            <div className="tabs_img">
                                                <img src={TowerIcon} className="img img-responsive" alt="client-img" />
                                            </div>
                                            <div className="bars_font">
                                                <h3 className="font_trigger" onClick={() => { setInputValue(item); }}>
                                                    <FontAwesomeIcon icon={faPenToSquare} />
                                                </h3>
                                                <h3 className="font_trigger" onClick={() => { ShowDeleteModal(item); }}>
                                                    <FontAwesomeIcon icon={faTrashCan} />
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="ClientText">
                                            <div className="l-two">
                                                <div className='d-flex' style={{justifyContent: "space-between"}}>
                                                    <h1>{item?.contactName}</h1>
                                                    {item?.isWhatsAppEnabled && (
                                                        <span title="WhatsApp Enabled" style={{ color: "#25D366", marginLeft: 8, fontSize: 22 }}>
                                                            <FontAwesomeIcon icon={faWhatsapp} />
                                                        </span>
                                                    )}
                                                    <span title="WhatsApp Enabled" style={{ color: "#17a2b8", marginLeft: 8, fontSize: 18, marginTop: 5 }}>
                                                        <FontAwesomeIcon icon={faPhone} />
                                                    </span>
                                                </div>
                                                <div className='d-flex' style={{justifyContent: "space-between"}}>
                                                    <h4>{item?.contactType}</h4>
                                                    <h4>{item?.contactNumber}</h4>
                                                </div>    
                                                <div className='d-flex' style={{justifyContent: "space-between"}}>
                                                    <h4 style={{maxWidth: 140}}>{item?.accessDays}</h4>
                                                    <h4 style={{maxWidth: 140}}>{item?.accessTimeRange}</h4>
                                                </div>    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <Modal centered show={DeleteShow} onHide={() => setDeleteShow(false)} dialogClassName="modal-100w" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                <div className="FnFtxt">
                                    <h2>Delete Contact</h2>
                                    <h3>Are you sure you want to delete?</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                        <div className='both_ConfrmBTN col-6' onClick={DeleteContact}>
                            <Button variant="danger">Delete</Button>{' '}
                        </div>
                        <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)}>
                            <Button variant="light">Cancel</Button>{' '}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default PriorityContacts;